/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FastIlsInfo } from '../../models/fast-ils-info';

export interface IlsControllerGetAllFastIlsInfos$Params {
}

export function ilsControllerGetAllFastIlsInfos(http: HttpClient, rootUrl: string, params?: IlsControllerGetAllFastIlsInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FastIlsInfo>>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerGetAllFastIlsInfos.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FastIlsInfo>>;
    })
  );
}

ilsControllerGetAllFastIlsInfos.PATH = '/ils/listAllFast';
